import styled from "styled-components";

const Title = styled.h1`
  color: ${props => props.theme.colors.black};
  font-size: 2.4rem;
  font-weight: 800;
  text-align: center;
`

export default Title;
